export enum AIContentGenerationStatus {
	Error = 'Error',
	Generating = 'Generating',
	Idle = 'Idle',
	Success = 'Success',
	TimeOut = 'TimeOut',
}
